import {
  STAGES, REQUEST_STATUSES, STAGE_PROBABILITY, normalizeStage, leadValueOf,
} from './leadConstants';

// Pure board helpers (unit-tested). UI + Firestore live elsewhere.

// Bucket leads into the pipeline stage columns (order preserved). Legacy stages
// are normalized so pre-revision leads still land in a column.
export function groupByStage(leads) {
  const cols = {};
  for (const s of STAGES) cols[s] = [];
  for (const l of leads || []) {
    const stage = normalizeStage(l.stage);
    if (cols[stage]) cols[stage].push(l);
  }
  return cols;
}

// Pipeline value (CRM revisions Task 4): raw = Σ lead value; weighted =
// Σ (lead value × stage probability). Stage normalized for legacy leads.
export function pipelineValue(leads) {
  let raw = 0;
  let weighted = 0;
  for (const l of leads || []) {
    const value = leadValueOf(l);
    raw += value;
    weighted += value * (STAGE_PROBABILITY[normalizeStage(l.stage)] ?? 0);
  }
  return { raw, weighted };
}

// Post-Won maintenance: Won deals (or explicit customers) become accounts to
// service, carrying their next scheduled visit.
export function customerVisits(leads) {
  return (leads || [])
    .filter((l) => (l.stage === 'Won' || l.lifecycle === 'customer') && !l.archived)
    .map((l) => ({
      id: l.id,
      businessName: l.businessName,
      territoryId: l.territoryId,
      category: l.category ?? null,
      tier: l.tier ?? null,
      serviceCadence: l.serviceCadence ?? null,
      coverageDays: Array.isArray(l.coverageDays) ? l.coverageDays : [],
      lastServiceAt: l.lastServiceAt ?? null,
      nextVisit: l.nextServiceAt ?? null,
      leadValue: leadValueOf(l),
      health: l.health ?? 'Healthy',
    }));
}

// Bucket requests into status columns.
export function requestsByStatus(requests, statuses = REQUEST_STATUSES) {
  const cols = {};
  for (const s of statuses) cols[s] = [];
  for (const r of requests || []) {
    if (cols[r.status]) cols[r.status].push(r);
  }
  return cols;
}
